import { Fragment, forwardRef, useEffect, useRef, useState } from "react"
import { useIsInViewport } from "../utils/CustomHooks"
import { BoltIcon } from "@heroicons/react/24/solid"
import { Link } from 'react-router-dom'
import { CommonTransition } from "../utils/CommonTransition"
import { Slider } from "../utils/Slider"
import { ASSETS_URL } from "../utils/constants"

const designDevelopment = ASSETS_URL + 'serv_designDevelopment.png'
const schematicDesign = ASSETS_URL + 'serv_schematicDesign.png'
const projectCosting = ASSETS_URL + 'serv_projectCosting.png'
const permitProcessing = ASSETS_URL + 'serv_permitProcessing.png'
const procurement = ASSETS_URL + 'serv_procurement.png'
const construction = ASSETS_URL + 'serv_construction.png'
const testingCommision = ASSETS_URL + 'serv_testing.png'

const BoltIconBullet = () =>{
    return <>
        <BoltIcon className='h-4 w-4 pr-1 text-[#2ba837] shrink-0 mt-1'/>
    </>
}

const systemDesignServices = [
    {
        name: 'Design Development',
        pic: designDevelopment,
        details: [
            'Data collection - Electric bill / Load Profile / Electrical Plans',
            'Site Inspection - Tapping point, Inverter room location',
            'PV System Simulation - PVsyst, Helioscope, Homer, Site Plan'
        ]
    },
    {
        name: 'Schematic Design',
        pic: schematicDesign,
        details: [
            'Module Layout',
            'Stringing',
            'Inverter / Transformer Location',
            'Single Line Diagram'
        ]
    },
    {
        name: 'Construction Drawings',
        pic: schematicDesign,
        details: [
            'Title Sheet, General Notes',
            'Site Plans',
            'SLD, Layouts, Schedule of loads'
        ]
    },
    {
        name: 'Project Costing',
        pic: projectCosting,
        details: [
            'Project Cost',
            'Electricity Rate / RESS / GMBD / Downgrading',
            'Saving',
            'Return of Investment'
        ]
    }
]


const systemConstructionServices = [
    {
        name: 'Permit Processing',
        pic: permitProcessing,
        details: [
            'OBO Electrical Permit',
            'Distribution Impact Study',
            'CoC Application'
        ]
    },
    {
        name: 'Procurement',
        pic: procurement,
        details: [
            'Module Panels',
            'Inverters',
            'AC/DC Wires',
            'Warranties'
        ]
    },
    {
        name: 'Construction',
        pic: construction,
        details: [
            'Structural Analysis',
            'Leak Test',
            'PV Module Installation',
            'AC/DC System Wiring',
            'Data Communication'
        ]
    }, 
    {
        name: 'Testing & Commisioning',
        pic: testingCommision,
        details: [
            'IV Curve Test',
            'PQA Test',
            'Insulation Test',
            'String Voltage Test'
        ]
    }
]
export const Services = () => {

    const containerRef = useRef(null)
    const isInViewport = useIsInViewport(containerRef)

    useEffect(() => {
        if(containerRef.current) {
          containerRef.current.parentNode.parentNode.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
        }
      }, [containerRef])
    return <>
    <div ref={containerRef} className='font-[Montserrat] text-[#4CB117] text-center text-3xl sm:text-5xl font-extrabold pb-3 pt-3'>Services</div>

    <div className="font-[Montserrat] text-[#f7f7f7] w-[80%]">
        <div className='text-[#f7f7f7] text-center text-sm sm:text-base pb-10'>At Total Solar Installation, we offer end-to-end services, from initial consultation, to design development, to permit processing, to construction, and to system monitoring and maintenance.</div>
        
    </div>

    <div className='font-[Montserrat] text-[#f7f7f7] w-[80%] text-left text-xl sm:text-2xl font-extrabold pt-4'>Solar PV System Design</div>
    <ServicesDetails id='service1' services={systemDesignServices} />

    <div className='font-[Montserrat] text-[#f7f7f7] w-[80%] text-left text-xl sm:text-2xl font-extrabold pt-4'>Solar PV System Construction</div>
    <ServicesDetails id='service2' services={systemConstructionServices} />


    <div className='font-[Montserrat] text-[#f7f7f7] text-center text-sm sm:text-base mt-10 w-[80%]'>Join us on our mission to create a cleaner, more sustainable future. Discover the power of solar energy with Total Solar Installation!</div>
    <div className='font-[Montserrat] text-[#f7f7f7] text-center text-sm sm:text-base mt-2 w-[80%]'><Link to={'/contact'} className='hover:underline text-[#4CB117]'>Send us a message for a free quotation!</Link></div>

    </>
}

const Card = forwardRef(({title, pic, margin, children}, ref) => {

    return <>
        <div ref={ref} className={`col-span-1 ${margin}`}>
            <div className="flex w-full flex-col justify-center xhover:-mt-3 translate duration-[250ms]">
                
                <img alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="aspect-video w-full h-[250px] object-cover object-center border-[1px] border-[#4CB117]" src={pic} />
                
                <div className="pt-3 pr-3">
                    <h1 className="text-left text-lg sm:text-xl text-bold font-medium pb-2 font-[Graphik Light] text-[#9aed79]">{title}</h1>
                    {children}
                </div>
            </div>
        </div>
    </>
})

const ServicesDetails = ({services, id}) => {
    const containerRef = useRef(null)
    const isInViewport = useIsInViewport(containerRef)
    const [animateOnce, setAnimateOnce] = useState(false)

    useEffect(() => {
        if(isInViewport) {
            setAnimateOnce(true)
        }
    },[isInViewport])

    const sliderConfig = {
        all: {
            enableAutoplay: false,
            autoplayInterval: 7000,
            transitionDuration: 200,
            slidesToShow: 1,
        },
      }
    return <>
    <div key={id} ref={containerRef} className="w-full flex justify-center pb-10">
        <div className={`w-[70%] hidden md:grid grid-cols-1 sm:grid-cols-4 gap-0 mt-5 sm:mt-10 ${!animateOnce && 'h-[100vh]'}`}>
            {
                services.map((service, index) => {
                    const duration = 2500 + (500*index)
                    const translate = 10 + (10*index)
                    const margin = 0 + (30*index)
                    return <Fragment key={id+index}>
                        <div className="hidden duration-[2500ms] duration-[3000ms] duration-[3500ms] duration-[4000ms]
                                        sm:mt-[0px] sm:mt-[30px] sm:mt-[60px] sm:mt-[90px] -translate-y-[10%] -translate-y-[20%] 
                                        -translate-y-[30%] -translate-y-[40%]" />
                        <CommonTransition open={animateOnce} durationEnter={`duration-[${duration}ms]`} enterFrom={`-translate-y-[${translate}%]`}>
                            <Card title={service.name} margin={`mt-3 sm:mt-[${margin}px]`} pic={service.pic}>
                                <div className="text-left text-[#f7f7f7] text-sm sm:text-base">
                                    {
                                        service.details.map((serviceDetail, detailIndex) => <Fragment key={'detail'+detailIndex}>
                                            <div className="flex pb-2"><BoltIconBullet/>{serviceDetail}</div>
                                        </Fragment>)
                                    }
                                </div>
                            </Card>
                        </CommonTransition>
                    </Fragment>
                })
            }
        </div>
        <div className="flex md:hidden w-[80%]">
            <Slider config={sliderConfig} navBtnClass={'text-white'}>
                {
                     services.map((service, index) => {
                        return <Fragment key={'slider'+id+index}>
                            <Card title={service.name} margin={`mt-3 px-8`} pic={service.pic}>
                                <div className="text-left text-[#f7f7f7] text-sm sm:text-base">
                                    {
                                        service.details.map((serviceDetail, detailIndex) => <Fragment key={'detail'+detailIndex}>
                                            <div className="flex pb-2"><BoltIconBullet/>{serviceDetail}</div>
                                        </Fragment>)
                                    }
                                </div>
                            </Card>
                        </Fragment>
                     })
                }
            </Slider>
        </div>
    </div>
    </>
}
